import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';
import { AML_SCREENING_STATUS } from '../../dataHandlers/amlScreeningConstants';
import { useGetCustomerAmlScreeningHandler } from '../../dataHandlers/getCustomerAmlScreeningHandler';
import { useResolveCustomerAmlScreeningHandler } from '../../dataHandlers/resolveCustomerAmlScreeningHandler';
import AmlScreeningInitialPanel from './AmlScreeningInitialPanel';
import AmlReScreenConfirmModal from './AmlReScreenConfirmModal';
import AmlScreeningSkeleton from './AmlScreeningSkeleton';
import AmlScreeningResultsPanel from './AmlScreeningResultsPanel';

export default function CustomerAmlScreeningSection({ profileId, isBusinessCustomer, customer }) {
  const { customers: c } = useTranslatedMessages();
  const aml = c?.amlScreening ?? {};
  const [reScreenModalOpen, setReScreenModalOpen] = useState(false);

  const { amlScreeningData, isLoading } = useGetCustomerAmlScreeningHandler(profileId, isBusinessCustomer);
  const runMutation = useResolveCustomerAmlScreeningHandler(profileId);

  const runScreening = async () => {
    try {
      await runMutation.mutateAsync({
        successMessage: aml.screenSuccess,
      });
      setReScreenModalOpen(false);
    } catch {
      // mutation onError shows snackbar
    }
  };

  if (!isBusinessCustomer) {
    return (
      <Box sx={{ py: 6, px: 2, textAlign: 'center', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
        {aml.businessOnlyMessage}
      </Box>
    );
  }

  if (isLoading || !amlScreeningData) {
    return <AmlScreeningSkeleton />;
  }

  const status = amlScreeningData.status;
  const isMatched = amlScreeningData.isMatched === 'Yes';

  if (status === AML_SCREENING_STATUS.CREDENTIALS_NOT_CONFIGURED) {
    return null;
  }

  if (status === AML_SCREENING_STATUS.NOT_SCREENED) {
    return (
      <AmlScreeningInitialPanel
        labels={{
          ...(aml.header ?? {}),
          ...(aml.initial ?? {}),
        }}
        onInitiate={runScreening}
        isRunning={runMutation.isPending}
      />
    );
  }
  return (
    <>
      <AmlScreeningResultsPanel
        data={amlScreeningData}
        labels={{
          ...(aml.header ?? {}),
          ...(aml.results ?? {}),
        }}
        onReScreen={() => setReScreenModalOpen(true)}
      />
      <AmlReScreenConfirmModal
        open={reScreenModalOpen}
        onClose={() => setReScreenModalOpen(false)}
        labels={aml.reScreenModal ?? {}}
        onConfirm={runScreening}
        isRunning={runMutation.isPending}
      />
    </>
  );
}
